import { FaWhatsapp } from "react-icons/fa";

export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/5493511234567?text=Hola%2C%20quiero%20más%20información%20sobre%20los%20servicios%20de%20VOLT%20Energía"
      className="whatsapp-btn"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Escribinos por WhatsApp"
    >
      <FaWhatsapp />
    </a>
  );
}
